import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";

type DeleteMappingModalProps = {
  isOpen: boolean;
  close: () => void;
  title: string;
  description: string;
  isLoading: boolean;
  onConfirm: () => void;
};

export const DeleteMappingModal = ({
  isOpen,
  close,
  title,
  description,
  isLoading,
  onConfirm,
}: DeleteMappingModalProps) => (
  <Modal.Root open={isOpen} onOpenChange={close}>
    <Modal.Content>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <Modal.Close />
      </Modal.Header>
      <Modal.Body>
        <div className="t-text-body-lg t-text-text-black">{description}</div>
      </Modal.Body>
      <Modal.FooterButtonGroup>
        <Modal.RawClose asChild>
          <Button type="button">Cancel</Button>
        </Modal.RawClose>
        <Button
          customType="danger"
          onClick={onConfirm}
          isLoading={isLoading}
          disabled={isLoading}
        >
          Remove
        </Button>
      </Modal.FooterButtonGroup>
    </Modal.Content>
  </Modal.Root>
);
